import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

export function useRdAggregateProducts() {
  return useQuery({
    queryKey: ['rd-aggregate-products'],
    queryFn: async () => {
      const response = await rdEquipamentosService.getAggregateProducts();
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar os produtos agregados do produto'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
  });
}
